import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthUrlManagerService, HeaderNames } from '@common/util-foundation';
import { Observable } from 'rxjs';

@Injectable()
export class AuthHeadersInterceptor implements HttpInterceptor {
  constructor(private authUrlManagerService: AuthUrlManagerService) {}
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url.includes('api.myaccount')) {
      //this is needed for AO identity API
      request = request.clone({
        setHeaders: {
          [HeaderNames.REQUEST_SOURCE]: 'AOCARE',
          [HeaderNames.REQUEST_ACTION]: 'MyAccount',
          [HeaderNames.CLIENT]: 'AOCARE',
        },
        url: this.authUrlManagerService.updateEndpoint(request.url),
      });
    }

    if (
      request.url.includes('api.person') ||
      request.url.includes('api.basket') ||
      request.url.includes('api.catalogue')
    ) {
      request = request.clone({
        setHeaders: {
          [HeaderNames.CLIENT]: 'AOCARE',
        },
      });
    }

    return next.handle(request);
  }
}
